import { useTranslation } from "react-i18next";
import classnames from "classnames";
import "./ContentFooter.style.scss";
import { MagicLink } from "../../ui";

interface ContentFooterProps {
    author?: string;
    siteName?: string | null;
    type: string;
    url?: string;
}

const ContentFooter = (props: ContentFooterProps) => {
    const { t } = useTranslation();
    const { siteName, author } = props;
    // if type is partner and both author and sitename not defined
    if (props.type === "partner" && !author && !siteName) {
        return null;
    }
    const footerClass = classnames("component-sponsor-footer", {
        [`${props.type}`]: props.type,
    });
    let footerText = "";
    if (props.type === "sponsored") {
        footerText = t("sponsored_footer", { author, siteName });
    } else if (props.type === "partner") {
        footerText = t("partner_footer");
    }
    return (
        <div className={footerClass}>
            <span className="footer-disclosure">
                {footerText}{" "}
                {props.type === "partner" ? (
                    props.url ? (
                        <MagicLink to={props.url} external={true}>
                            {siteName}
                        </MagicLink>
                    ) : (
                        siteName
                    )
                ) : null}
            </span>
        </div>
    );
};

export default ContentFooter;
